import { useLocation } from 'react-router-dom';

/** Customer UI lives under Bike Sales or Order Receiver — same API, different menu paths. */
export function useCustomerBasePaths() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/order-receiver/')) {
    return {
      list: '/order-receiver/customers',
      create: '/order-receiver/customers/create',
      isOrderReceiver: true,
    };
  }
  return {
    list: '/sales/customers',
    create: '/sales/customers/create',
    isOrderReceiver: false,
  };
}
